import { render } from "./TaxesForm.vue?vue&type=template&id=3216b34b&scoped=true"
import script from "./TaxesForm.vue?vue&type=script&lang=js"
export * from "./TaxesForm.vue?vue&type=script&lang=js"

import "./TaxesForm.vue?vue&type=style&index=0&id=3216b34b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216b34b"]])

export default __exports__